<ul class="app-checkboxset list-group">
<ng-template [ngIf]="!groupby" [ngIfElse]="groupedListTemplate">
  <li (click)="onCheckboxLabelClick($event, item.key)"
      *ngFor="let item of datasetItems; let i = index"
      [class.active]="item.selected"
      [ngClass]="['checkbox', 'app-checkbox']">
<!--      [userComponentParams]="item" [wmItemTemplate]="content" partialContainer>-->

    <!-- Default item template -->
    <label class="app-checkboxset-label" [title]="item.label">
      <input [name]="'checkboxset_' + propPanel?.activeWidget?.widgetId" type="checkbox" [attr.aria-label]="item.key"
             [attr.aria-checked]="item.selected"
             [attr.data-attr-index]="i"
             [value]="item.key" [checked]="item.selected"/>
      <span class="caption" [textContent]="item.label"></span>
    </label>
  </li>
</ng-template>

<ng-template #groupedListTemplate>
  <div>groupedListTemplate</div>
<!--  <li *ngFor="let groupObj of groupedData" class="app-list-item-group">-->
<!--    <ul class="item-group">-->
<!--      <li class="list-group-header" (click)="handleHeaderClick($event)" [title]="groupObj.key" [ngClass]="{'collapsible-content': collapsible}">-->
<!--        <h4 class="group-title">{{groupObj.key}}-->
<!--          <div class="header-action">-->
<!--            <i class="app-icon wi action wi-chevron-up" *ngIf="collapsible" title="{{appLocale.LABEL_COLLAPSE}}/{{appLocale.LABEL_EXPAND}}"></i>-->
<!--            <span *ngIf="showcount" class="label label-default" [textContent]="groupObj.data.length"></span>-->
<!--          </div>-->
<!--        </h4>-->
<!--      </li>-->
<!--      <li *ngFor="let item of groupObj.data; let i = index;"-->
<!--          [ngClass]="['checkbox', 'app-checkbox', 'group-list-item', itemclass, itemsPerRowClass]"-->
<!--          [class.active]="item.selected"-->
<!--          [wmItemTemplate]="content" [userComponentParams]="item" partialContainer-->
<!--          (click)="onCheckboxLabelClick($event, item)">-->
<!--        &lt;!&ndash; Default item template &ndash;&gt;-->
<!--        <label *ngIf="!content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" [title]="item.label">-->
<!--          <input [name]="'checkboxset_' + widgetId" type="checkbox" aria-label="checkbox group"-->
<!--                 [tabindex]="tabindex"-->
<!--                 [disabled]="disabled || readonly" [attr.data-attr-index]="i"-->
<!--                 [value]="item.key" [tabindex]="tabindex" [checked]="item.selected"/>-->
<!--          <span class="caption" [textContent]="item.label"></span>-->
<!--        </label>-->
<!--        &lt;!&ndash; Custom partial template &ndash;&gt;-->
<!--        <label *ngIf="content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" >-->
<!--          <input [name]="'checkboxset_' + widgetId" type="checkbox" aria-label="checkbox group"-->
<!--                 [tabindex]="tabindex"-->
<!--                 [disabled]="disabled || readonly" [attr.data-attr-index]="i"-->
<!--                 [value]="item.key" [tabindex]="tabindex" [checked]="item.selected"/>-->
<!--          <span class="caption" partial-container-target></span>-->
<!--        </label>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </li>&ndash;&gt;-->
</ng-template>
  </ul>
